import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useNavigateHook = () => {
  const navigate = useNavigate();

  const doNavigate = useCallback(
    async (routePath: any, replace = false) => {
      navigate(routePath, { replace });
    },
    [navigate]
  );

  return { doNavigate };
};

export default useNavigateHook;
